var LabourAndWait = LabourAndWait || {};

LabourAndWait.init = function(){
  LabourAndWait.fluidNav();
  LabourAndWait.fadeProducts();
  LabourAndWait.slideShow();
  LabourAndWait.account();
  LabourAndWait.product();
  LabourAndWait.moreImages();
  LabourAndWait.toggleOverlays();
  LabourAndWait.notifyStock();
  LabourAndWait.toggleOrder();
  
  if ($('body').is('.faqs')) LabourAndWait.wrapFAQs();
  if ($('body').is('.contact')) LabourAndWait.googleMap();
  if ($('body').is('.cart')) {
    LabourAndWait.updateProducts();
    LabourAndWait.wrapDelivery();
  }
	
  var template = $('body').data('template');
  
  if (template === 'collection' || template === 'list-collections') {
    LabourAndWait.stickyMenu();
  }
}

LabourAndWait.product = function() {
  $('.product-form').submit(function(event) {
    event.preventDefault();
    $btn = $(this).find('.btn');
    $btn.attr('disabled', 'disabled').addClass('disabled').val('...');
    $.ajax({
      method: 'POST',
      url: '/cart/add.js',
      data: $(this).serialize(),
      dataType: 'json',
      success: function(data) {
        LabourAndWait.basket($btn);
      },
      error: function(data){
        console.log('fail');
      }
    });
  });  
};

LabourAndWait.basket = function(clicked){
  $.getJSON('/cart.js').done(function(data) {
    var price = data.total_price/100,
        $elements = $('#view-cart, .handles .basket');
        $btnCopy=clicked.val();

    $elements.addClass('flash');
    clicked.val('ADDED');
    setTimeout(function() { 
      $elements.removeClass('flash');
      clicked.attr('disabled', false).removeClass('disabled').val('ADD\nTO\nBAG');
    }, 1500);

    $('.item-count').text(data.item_count);

    var localePrice = "¥"+price.toFixed(2);

    $('#total-price').text(localePrice);
  });
}

LabourAndWait.basket2 = function(clicked){
  $.getJSON('/cart.js').done(function(data) {
    var price = data.total_price/100,
        $elements = $('#view-cart, .handles .basket');
        $btnCopy=clicked.val();

    $elements.addClass('flash');
    clicked.val('ADDED');
    setTimeout(function() { 
      $elements.removeClass('flash');
      clicked.attr('disabled', false).removeClass('disabled').val('PRE\nORDER');
    }, 1500);

    $('.item-count').text(data.item_count);

    var localePrice = "¥"+price.toFixed(2);

    $('#total-price').text(localePrice);
  });
}


LabourAndWait.wrapFAQs = function() {
  var container = $('body.faqs .page-copy');

  $('h3', container).each(function() {
    var ps = []

    $(this).nextAll().each(function() {
      if ($(this).is('h3') || $(this).is('h2')) return false;
      else if ($(this).is('p')) ps.push(this);
    });

    var toggle = $('<div class="toggle" />').append(ps).hide();
    var div = $('<div class="arrowed" />').append(toggle).insertAfter(this);

    div.prepend(this);

    $(this).click(function() {
      $(this).parent('.arrowed').toggleClass('open')
      $(this).next('.toggle').slideToggle();
    })
  });
}

LabourAndWait.wrapDelivery = function() {
  var container = $('body.cart .delivery-returns');

  $('h3', container).each(function() {
    var ps = []

    $(this).nextAll().each(function() {
      if ($(this).is('h3') || $(this).is('h2')) return false;
      else if ($(this).is('ul')) ps.push(this);
    });

    var toggle = $('<div class="toggle" />').append(ps).hide();
    var div = $('<div class="arrowed" />').append(toggle).insertAfter(this);

    div.prepend(this);

    $(this).click(function() {
      $(this).parent('.arrowed').toggleClass('open')
      $(this).next('.toggle').slideToggle();
    })
  });
}

LabourAndWait.googleMap = function(){
  if($('#gmap[data-glat][data-glong]').length > 0){
    var glatlong = new google.maps.LatLng($('#gmap').attr('data-glat'), $('#gmap').attr('data-glong'))
    var myOptions = {
      center: glatlong,
      zoom: 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map(document.getElementById("gmap"),myOptions);
    var marker = new google.maps.Marker({
          position: glatlong,
          map: map
      });
  }
}

LabourAndWait.slideShow = function(){
  $('.ss').each(function(){
    if ( $(this).find('img').length > 1 ) {
      var autoplay = $(this).data('auto') ? true : false;
      $(this).slidesjs({
        width: 460,
        height: 460,
        play: {
          auto: autoplay,
          pauseOnHover: true,
          effect: "fade"
        },
        effect:{
          fade: { speed: 500 }
        },
        navigation: { 
          active: false,
          effect: "fade" 
        },
        pagination: { effect: "fade" }
      });
    }
  })
}

LabourAndWait.fadeProducts = function(related) {
    function imageTest(img) {
        if (!img.complete) return false;
        if (img.naturalWidth === 0) return false;
        return true;
    }
    
  	function onLoad(img) {
      $(img).animate({opacity: 1});
      $(img).addClass('loaded');
  	}
  
    function imageLoaded(img) {
        $(img).parent().addClass('has-placeholder');
        
        if (imageTest(img)) onLoad(img);
        else $(img).load(function(){ onLoad(img); });
    }

    if (!related) {
        var ss_img = $('.ss img');

        if (ss_img.length === 1) {
            ss_img.css({opacity: 0});
            imageLoaded(ss_img[0]);
        }
        
        var main_img = $('#content >  > img');
      
        main_img.css({opacity: 0});
        main_img.each(function() { imageLoaded(this) });
    }
    
  $('.product-photo:not(.loaded)').css('opacity', 0).each(function() { imageLoaded(this) });
    
}

LabourAndWait.account = function() {
  $('[data-toggle]').click(function(event) {
    event.preventDefault();

    var $link = $(this);
    var $all = $($link.data('toggle'));
    var $target = $($link.attr('href'));

    $all.hide();

    if ($(this).data('isToggled')) {
      $target.hide();
      $link.data('toggle-alt', $link.text());
      $link.text($link.data('toggle-text') || $link.data('toggle-alt'));
      $link.data('isToggled', false);
    } else {
      $target.show();
      $link.data('toggle-text', $link.text());
      $link.text($link.data('toggle-alt') || $link.data('toggle-text'));
      $link.data('isToggled', true);
    }
  });

  $('#reset-password').hide();

  if (LabourAndWait.loggedIn) {
    $('.account-link a').text('Account');
  }

  if (LabourAndWait.cartSize > 0) {
    $('.cart-link').addClass('full');
    $('.cart-label').text(LabourAndWait.cartSize);
  }
}

LabourAndWait.stickyMenu = function() {
  var height = $('.sub-nav').height();
  var shouldStick = function() {
    return (height < $(window).height() - 10 && $(window).width() > 660 && window.outerWidth > 660);
  } 
   
  var points = [

    {
      at: function() { return $('#content').offset().top - 50; },

      reset: function() {
        var el = $('#main .sub-nav');

        el.removeClass('sticky');
        el.css({ top: '' });
        el.addClass('absolutely');
        
      },

      trigger: function(e) {
        var el = $('#main .sub-nav');
        if (!shouldStick() || e.direction === -1) {
          this.reset();
          return;
        }
        
        
        if (e.direction === 1) {
          el.addClass('sticky');
          el.css({ top: 50 });
          el.removeClass('absolutely');
        }
      }
    },

    {
      at: function() { return $('.holder').height() - $('.sub-nav').height() - 100 },

      reset: function() {
        var el = $('#main .sub-nav');

        el.removeClass('sticky absolutely');
        el.css({ top: '' });
      },

      trigger: function(e) {
        var el = $('#main .sub-nav');

        if (!shouldStick()) {
          this.reset();
          return;
        }

        if (e.direction === -1) {

          el.addClass('sticky');
          el.css({ top: 50 });
          el.removeClass('absolutely');
        }

        if (e.direction === 1) {
          el.removeClass('sticky');
          el.css({ top: e.target + 30 });
          el.addClass('absolutely');
        }

      }
    }

  ];
  
  window.scroller = new ScrollTrigger({ points: points });

  $(window).scroll(function() {
    scroller.checkPoints();
  }).resize(function() {
    scroller.refresh();
  });

}

LabourAndWait.toggleOverlays = function(){
	var toggle = $('.toggle');
  $('.holder').after($('.overlay').detach());
	toggle.click(function(){
    if ($(this).hasClass('close')) {
      $('body').removeClass('no-scroll');
      $(this).closest('.overlay').hide();
    }else{
      $('body').addClass('no-scroll');
      if ($(this).hasClass('toggle-nav')) $('#responsive-nav').show();
      if ($(this).hasClass('toggle-search')) {
        $('.overlay:not(#search-overlay)').hide();
        $('#search-overlay').show();
      }
      if ($(this).hasClass('toggle-shipping')) {
        $('.overlay:not(#shipping-overlay)').hide();
        $('#shipping-overlay').show();
      }
      if ($(this).hasClass('toggle-notify')) {
        var overlay_id = "#notify-"+$(this).data("product-id");
        $(overlay_id).show();
      }
      if ($(this).hasClass('toggle-image')) {
        var overlay_id = "#image-overlay-"+$(this).data("image-id");
        $(overlay_id).show();
      }
    }
	})
}

LabourAndWait.updateProducts = function(){
  $('select.item-quantity').change(function(){
    $('#cartform').submit();
  })
  $('.remove').click(function(){
    $(this).prev().val(0);
    $('#cartform').submit();
  })
}

LabourAndWait.notifyStock = function(){
	$('.toggle-notify').click(function(){
    $(this).next().toggle();
	})
  
  var notifyCallback = function(data) {
    if (data.status === 'OK') {
      $('.notify-form-inner').replaceWith('<p>Thank you</p>');
    } else {
      $('.notify-status').empty();

      $.each(data.errors, function(key, errors) {
        $.each(errors, function(key, error) {
          $('.notify-status').append(error + '<br />');
        });
      });
    }
  };

  $('.notify-submit').click(function(e) {
    e.preventDefault();
    
    var notify_form = $(this).parents('.notify-form'),
        notify_email = notify_form.find('.notify-email').val(),
        notify_variant_id = notify_form.find('.variant-id').first().val(),
        notify_product_id = notify_form.find('.product-id').first().val();

    BISPopover.create(
      notify_email,
      notify_variant_id,
      notify_product_id
    ).then(notifyCallback);
    
    return false;
  })
}

LabourAndWait.fluidNav = function(){
  var $nav = $('#header .navigation.main-menu');
  var $container = $nav.parent();

  var $navItems = $nav.find('li');
  var numNavItems = $navItems.length;

  $nav.css({ opacity: 0 });

  $(window).on('resize', function() {
    sizeNavItems();
  });

  $(window).on('load', function() {
    $(window).resize();
    $nav.animate({ opacity: 1 });
  });

  function sizeNavItems() {
    $navItems
      .find('a')
      .css({ marginLeft: 0 });

    var containerWidth = $container.width();
    var navWidth = $nav.width() + 1 /* on iPad landscape last item knocks onto next line without this + 1 */;

    var guttersSum = containerWidth - navWidth;
    var gutterWidth = Math.floor((guttersSum - 1) / (numNavItems - 1));

    $navItems
      .not(':first-child')
      .find('a')
      .css({ marginLeft: gutterWidth });
  }
}

LabourAndWait.moreImages = function(){
  $('.image-grid img').each(function(i){
    var img = $(this),
        img_clone = img.clone(),
        close_link = $('<div class="close toggle">CLOSE</div>'),
        overlay_content = close_link.add(img_clone).wrapAll('<div class="card"></div>').parent(),
        overlay = overlay_content.wrapAll('<div class="overlay image-overlay" id="image-overlay-'+i+'"></div>').parent();
    img.wrap('<a href="#" class="toggle toggle-image" data-image-id="'+i+'"></a>');
    $('.holder').after(overlay);
  })
}

LabourAndWait.toggleOrder = function(){
  $('.orders__table .openclose').each(function(){
    var toggler = $(this);
    toggler.css({'text-decoration':'underline', 'cursor':'pointer'})
    toggler.click(function(){
      var toggleThis = $(this).closest('tr').next().find('.order__line-items');
      toggleThis.toggle();
    })
    toggler.click();
  })
}

$(document).ready(function() {
    LabourAndWait.init();
  
  var isLoading = false;

  function loadMore() {
    var next = $('.pagination .current').next('span').find('a');

    isLoading = true;

    if (next.size()) {
      var href = next.attr('href');

      $('<div />').load(href + ' .products ', function() {
        var temp = $(this);
        var lis = temp.find('.products li');
        var pagination = temp.find('.pagination').hide();
                
        $('.products').append(lis);
        LabourAndWait.product();
        $('.pagination').replaceWith(pagination);
      
        LabourAndWait.fadeProducts();
        isLoading = false;
      
        scroller && scroller.refresh();
      });
    }
  }

  $(window).scroll(function() {
    if (isLoading) return;
  
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 1000) {
   	  loadMore();
    }
  });

});
